<template>
<b-modal
hide-footer
title="Seleccione gestores para excel de metricas"
id="select-gestores-for-excel-metricas">

	<b-form-select
	class="m-b-15"
	v-model="aseguradora_id"
	:options="getOptions({key: 'aseguradora_id', text: 'Seleccione aseguradora'})"></b-form-select>

	<b-form-checkbox
	v-for="gestor in gestores"
	:key="gestor.id"
	:value="gestor.id"
	@change="set_selected_gestores"
	v-model="gestores_ids">
		{{ gestor.nombre }}
	</b-form-checkbox>

	<b-button-group
	class="w-100">
		
		<b-button
		block
		class="m-t-15"
		@click="set_all_gestores"
		variant="outline-success">
			<span
			v-if="gestores_ids.length">
				Deseleccionar todo
			</span>
			<span
			v-else>
				Seleccionar todo
			</span>
		</b-button>

		<b-button
		block
		class="m-t-15"
		@click="excel"
		variant="success">
			Exportar Excel
		</b-button>
	</b-button-group>
</b-modal>
</template>
<script>
export default {
	// created() {
	// 	this.set_gestores()
	// },
	data() {
		return {
			gestores_ids: [],
			aseguradora_id: 0,
		}
	},
	computed: {
		gestores() {
			return this.$store.state.gestor_aseguradora.models 
		},
		_from() {
			return this.$store.state.siniestro_metricas.casos_por_dia.from_date
		},
		_until() {
			return this.$store.state.siniestro_metricas.casos_por_dia.until_date
		},
	},
	methods: {
		set_selected_gestores() {
			console.log(this.gestores_ids)
			// this.gestores_ids = 
			// this.$store.commit('siniestro_metricas/excel_metricas/set_gestores_ids', this.gestores_ids)
		},
		excel() {
			let link = process.env.VUE_APP_API_URL+'/excel/metricas/'+this._from+'/'+this._until+'/'+this.aseguradora_id+'/'+this.gestores_ids.join('-')
			window.open(link)
		},
		set_all_gestores() {

			let ids = []
			
			if (!this.gestores_ids.length) {

				this.gestores.forEach(gestor => {
					ids.push(gestor.id)
				})
			}

			this.gestores_ids = ids
			this.$store.commit('siniestro_metricas/excel_metricas/set_gestores_ids', ids)
		}
	}
}
</script>